export default "__VITE_ASSET__BkmfLpbk__"